import React, { useState } from "react";
import { connect } from "react-redux";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Modal from "@mui/material/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Button,
  MenuItem,
  Select,
  TextField,
  Grid,
  TableCell,
  TableContainer,
  Table,
  withStyles,
  TableBody,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloseIcon from "@material-ui/icons/Close";
import {
  raiseNewTicektDisposition,
  initiateRefund,
  getTestList,
} from "../../actions/OffLineSupportActions";
import { useEffect } from "react";
import Loader from "../../components/Loader2";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "3px solid green",
    borderRadius: "5px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "1200px",
  },
  head: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  table: {
    maxWidth: "100%",
    margin: "auto",
    overflow: "scroll",
  },
  tableContainer: {
    marginTop: "2rem",
    position: "sticky",
    overflow: "scroll",
  },
}));
const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#178073",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

type ModalProps = {
  open: boolean;
  bookingId: any;
  raiseNewTicektDisposition: any;
  bookingComplaints: any;
  leadId: any;
  setOpen: Function;
  ticketLoader: boolean;
  initiateRefund: any;
  totalPrice: any;
  booking: any;
  getTestList: any;
  TestList: any;
};

const CommentsModal2: React.FC<ModalProps> = ({
  open,
  bookingId,
  leadId,
  raiseNewTicektDisposition,
  bookingComplaints,
  setOpen,
  ticketLoader,
  initiateRefund,
  totalPrice,
  booking,
  getTestList,
  TestList,
}) => {
  const classes = useStyles();
  const [query, setQuery] = useState("none");
  const [description, setDescription] = useState("");
  const [newTicket, setNewTicket] = useState<boolean>(false);
  const [disposition, setDisposition] = useState<any>("");
  const [subTicketType, setSubTicketType] = useState<any>("");
  const [createBookingId, setCreateBookingId] = useState<any>(bookingId);
  const [createAmount, setCreateAmount] = useState<any>(totalPrice);
  const [finalAmount, setFinalAmount] = useState<any>("");
  const [paidTotalAmout, setPaidTotalAmout] = useState<any>("");
  const [FocCreateBookingId, setFocCreateBookingId] = useState<any>("");
  const [inaccurateReport, setInaccuarteReport] = useState<any>();
  const [correctName, setCorrectName] = useState<any>();
  const [packageList, setPackageList] = useState<any>([]);
  const [file, setFile] = useState<any>();
  const blockCharInPhoneField = (e: React.KeyboardEvent<HTMLDivElement>) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  const handleClose = () => {
    setDisposition("");
    setOpen("");
    setSubTicketType("");
    setNewTicket(false);
    setInaccuarteReport("");
    setCorrectName("");
    setFile("");
    setPackageList("");
  };
  useEffect(() => {
    if (booking?.paid_amount !== undefined && booking?.paid_amount !== null) {
      setFinalAmount(booking?.paid_amount);
      setPaidTotalAmout(booking?.discounted_price?.final_total_price)
    }
  }, [booking]);

  useEffect(() => {
    setCreateAmount(finalAmount);
  }, [finalAmount]);
  
useEffect(() => {
if (bookingId!==0){
    getTestList(`?booking_id=${bookingId}`);  
}
},[]);
  useEffect(() => {
    if (subTicketType) {
      setCorrectName("");
      setFile("");
      setPackageList("");
      setInaccuarteReport("");
    }
  }, [subTicketType]);

  const raiseComplaint = () => {

    // const body1: any = {
    //   query: description,
    //   disposition: disposition,
    //   sub_ticket_type: subTicketType,
    //   lead_id: leadId,
    //   booking_id: bookingId,
    //   querytype: "doctor",
    //   reference_booking_id: FocCreateBookingId,
    //   correct_data: correctName,
    //   // correct_age:correctAge,
    //   // correct_gender:correctGender,
    //   // correct_doctor:correctDoctor,
    //   reason: inaccurateReport,
    //   // inaccuratereport_packages:packageList.join(","),
    //   document: file,
    // };
    const formData = new FormData();

    formData.append("query", description);
    formData.append("disposition", disposition);
    formData.append("sub_ticket_type", subTicketType);
    formData.append("lead_id", leadId);
    formData.append("booking_id", bookingId);
    formData.append("querytype", "doctor");
    formData.append("reference_booking_id", FocCreateBookingId);
    formData.append("correct_data", correctName);
    formData.append("reason", inaccurateReport);
    formData.append("inaccuratereport_packages", packageList);
    formData.append("document", file);


    const body4: any = {
      amount: createAmount === "" ? 0 : Number(createAmount),
      booking: createBookingId,
      cs_remarks: description,
    };
    if (correctName === "") {
      formData.delete('correct_data');
    }
    if (inaccurateReport === "") {
      formData.delete('reason');
    }

    if (packageList === "") {
      formData.delete('inaccuratereport_packages');
    }

    if (file === "") {
      formData.delete('document');
    }

    if (disposition === "") {
      formData.delete('disposition');
    }

    if (disposition !== "foc_queries") {
      formData.delete('reference_booking_id');
    }

    if (leadId === 0) {
      formData.delete('lead_id');
    }

    if (disposition !== "doctor_consultation") {
      formData.delete('querytype');
    }

    // if (disposition === "") {
    //   delete body1.disposition;
    // }
    // if (disposition !== "foc_queries") {
    //   delete body1.reference_booking_id;
    // }
    // if (leadId === 0) {
    //   delete body1["lead_id"];
    // }
    // if (disposition !== "doctor_consultation") {
    //   delete body1["querytype"];
    // }
    if (
      disposition === "refund_query" &&
      booking &&
      booking?.booking_type === "b2c"
    ) {

      initiateRefund(body4);
      setQuery("none");
      setDescription("");
      handleClose();
    } else {
      raiseNewTicektDisposition(formData);
      setQuery("none");
      setDescription("");
      handleClose();
    }
  };

  const handleCross = () => {
    setOpen(false);
    setNewTicket(false);
  };
  useEffect(() => {
    setCreateBookingId(bookingId);
  }, [bookingId]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.head}>
              <h4 style={{ fontWeight: "bolder" }}>Raise A Query Ticket</h4>
              <CloseIcon onClick={handleCross} />
            </div>
            {bookingComplaints?.results &&
              bookingComplaints?.results.length > 0 &&
              !newTicket ? (
              <>
                <TableContainer
                  className={classes.tableContainer}
                  style={{ maxHeight: "400px" }}
                >
                  {ticketLoader ? (
                    <Loader />
                  ) : (
                    <Table stickyHeader aria-label="simple table">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell align="center">
                            Booking Id
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Child Id
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Agent
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Created At
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Query Type
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Query Description
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Receiver Remarks
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Status
                          </StyledTableCell>
                          <StyledTableCell align="center">View</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {bookingComplaints?.results &&
                          bookingComplaints?.results.length > 0 &&
                          bookingComplaints?.results.map(
                            (ticket: any, index: any) => {
                              return (
                                <StyledTableRow key={index}>
                                  <StyledTableCell align="center">
                                    {ticket?.booking !== null
                                      ? ticket?.booking?.id ||
                                      ticket?.booking?.pk
                                      : ticket?.add_booking?.mainbooking}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {ticket?.booking === null
                                      ? ticket?.add_booking?.id
                                      : ""}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {ticket.panel_user &&
                                      ticket.panel_user.name}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {new Date(
                                      ticket.created_at
                                    ).toLocaleString()}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {ticket.querytype}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {ticket.query}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {ticket.receicer_remarks}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    {ticket.status}
                                  </StyledTableCell>
                                  <StyledTableCell align="center">
                                    <Link
                                      to={`/dashboard/os/booking-view/${ticket?.booking !== null
                                        ? ticket?.booking?.id ||
                                        ticket?.booking?.pk
                                        : ticket?.add_booking?.mainbooking
                                        }`}
                                    >
                                      <Button
                                        style={{
                                          backgroundColor: "rgb(232 179 57)",
                                        }}
                                        variant="contained"
                                      >
                                        View
                                      </Button>
                                    </Link>
                                  </StyledTableCell>
                                </StyledTableRow>
                              );
                            }
                          )}
                      </TableBody>
                    </Table>
                  )}
                </TableContainer>
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    height: "50px",
                    marginTop: "50px",
                    backgroundColor: "#7ed27e",
                  }}
                  onClick={() => setNewTicket(true)}
                >
                  Do You Want to Raise New Ticket
                </Button>
              </>
            ) : (
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                justify="space-between"
                spacing={3}
                style={{ margin: "1rem auto" }}
              >
                <Grid item xs={12}>
                  <p>Ticket Type</p>
                  <Select
                    className="input"
                    name="action"
                    variant="outlined"
                    value={disposition}
                    style={{ width: "100%" }}
                    onChange={(e) => setDisposition(e.target.value as string)}
                  >
                   
                    
                   
                    <MenuItem value={"fault_report"}>
                      Report Related Query
                    </MenuItem>
                   
                  </Select>
                </Grid>
                {disposition === "fault_report" && (
                  <Grid item xs={12}>
                    <p>Sub Ticket Type</p>
                    <Select
                      className="input"
                      name="sub_ticket_type"
                      variant="outlined"
                      value={subTicketType}
                      style={{ width: "100%" }}
                      onChange={(e) =>
                        setSubTicketType(e.target.value as string)
                      }
                    >
                      <MenuItem value={"inaccurate_report"}>
                        Inaccurate Report
                      </MenuItem>
                      <MenuItem value={"name_correction"}>
                        Name Correction
                      </MenuItem>
                      <MenuItem value={"age_correction"}>
                        Age Correction
                      </MenuItem>
                      <MenuItem value={"gender_correction"}>
                        Gender Correction
                      </MenuItem>
                      <MenuItem value={"doctor_name_to_be_updated"}>
                        Doctor Name to be updated
                      </MenuItem>
                      <MenuItem value={"passport_addition"}>
                        Passport Addition
                      </MenuItem>
                      <MenuItem value={"smart_report_required"}>
                        Smart Report required
                      </MenuItem>
                      <MenuItem value={"barcode_scanning_issue"}>
                        Barcode scanning issue
                      </MenuItem>
                      {/* <MenuItem value={"others"}>
                        Others (Passport addition, Smart report required,lab
                        address in correct, barcode related etc)
                      </MenuItem> */}
                    </Select>
                  </Grid>
                )}
                {disposition === "fault_report" && subTicketType === "inaccurate_report" &&
                  (
                    <>
                      {/* <Grid item xs={12} sm={6} md={6}>
                        <p>Select Test* </p>
                        <Autocomplete
                          id="package"
                          onChange={(event, newValue) => {
                            if (newValue) {
                              let packs: any = [];
                              newValue.map((val: any) => {
                                let obj = JSON.parse(JSON.stringify(val, null, " "));
                                packs.push(obj.id);
                              });
                              setPackageList(packs);
                            }
                          }}
                          multiple
                          options={booking?.packages || []}
                          disableClearable
                          limitTags={0}
                          getOptionLabel={(option: any) => {
                            return option?.name + " " + option?.code;
                          }}
                          getOptionDisabled={(option: any) => {
                            const packID: any = packageList&&packageList?.map((pack: any) => pack);
                            return packID?.includes(option?.id);
                          }}
                          renderOption={(option: any) => {
                            return (
                              <p style={{ margin: "0 10px" }}>
                                <strong style={{ color: "blue" }}>
                                  {option?.name.toString()}
                                </strong>
                                {" "}
                                ({option?.code?.toUpperCase()})
                              </p>
                            );
                          }}
                          freeSolo
                          disableCloseOnSelect
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Package"
                              variant="outlined"
                              style={{ width: "100%", margin: "0", padding: "0" }}
                              className="input"
                              required
                            />
                          )}
                        />
                      </Grid> */}
                     <Grid item xs={12} sm={6} md={6}>
                        <p>Select Test* </p>
                        <Autocomplete
                          id="package"
                          onChange={(event, newValue) => {
                            if (newValue) {
                              let packs: any = [];
                              newValue.map((val: any) => {
                                let obj = JSON.parse(JSON.stringify(val, null, " "));
                                packs.push(obj.id);
                              });
                              setPackageList(packs);
                            }
                          }}
                          multiple
                          options={TestList?.tests || []}
                        //   options={booking?.booking_tests_list
                        //     || []}
                          disableClearable
                          limitTags={0}
                          getOptionLabel={(option: any) => {
                            return option?.name + " " + option?.code;
                          }}
                          getOptionDisabled={(option: any) => {
                            const packID: any = packageList&&packageList?.map((pack: any) => pack);
                            return packID?.includes(option?.id);
                          }}
                          renderOption={(option: any) => {
                            return (
                              <p style={{ margin: "0 10px" }}>
                                <strong style={{ color: "blue" }}>
                                  {option?.name.toString()}
                                </strong>
                                {" "}
                                ({option?.code?.toUpperCase()})
                              </p>
                            );
                          }}
                          freeSolo
                          disableCloseOnSelect
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Package"
                              variant="outlined"
                              style={{ width: "100%", margin: "0", padding: "0" }}
                              className="input"
                              required
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <p>Reason for Inaccurate report (VOC)*</p>
                        <Select
                          className="input"
                          name="sub_ticket_type"
                          variant="outlined"
                          value={inaccurateReport}
                          style={{ width: "100%" }}
                          required
                          onChange={(e) =>
                            setInaccuarteReport(e.target.value as string)
                          }
                        >
                          <MenuItem value={"based_on_another_report"}>
                            Based on another report
                          </MenuItem>
                          <MenuItem value={"medication"}>
                            Medication
                          </MenuItem>
                          <MenuItem value={"test_instruction_not_followed"}>
                            Test instructions not followed
                          </MenuItem>
                          <MenuItem value={"allergy"}>
                            Allergy
                          </MenuItem>
                          <MenuItem value={"fasting_not_done"}>
                            Fasting not done
                          </MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <p>Upload report/ clinician history</p>
                        <input
                          className="input"
                          style={{
                            width: "100%",
                            marginTop: "-15px",
                            marginBottom: "10px",
                            padding: "18.5px 14px",
                            border: "1px solid rgba(0, 0, 0, 0.23)",
                            borderRadius: "5px",
                          }}
                          type="file"
                          name="file"
                          id="file"
                          accept=".png, .jpg, .jpeg,.pdf"

                          onChange={(e: any) => setFile(e.target.files[0])}
                        />
                      </Grid>
                    </>
                  )
                }
                {disposition === "fault_report" && subTicketType === "name_correction" &&
                  <Grid item xs={12} sm={6} md={6}>
                    <p>Enter Correct Name*</p>
                    <TextField
                      className="input"
                      name="name"
                      type="text"
                      size="medium"
                      value={correctName}
                      variant="outlined"
                      required
                      onChange={(e) => setCorrectName(e.target.value)}
                      style={{ width: "100%", height: "50px" }}
                    />
                  </Grid>}
                {disposition === "fault_report" && subTicketType === "age_correction" &&
                  <Grid item xs={12} sm={6} md={6}>
                    <p>Enter Correct Age*</p>
                    <TextField
                      className="input"
                      name="name"
                      type="number"
                      size="medium"
                      value={correctName}
                      required
                      variant="outlined"
                      onChange={(e) => setCorrectName(e.target.value)}
                      style={{ width: "100%", height: "50px" }}
                    />
                  </Grid>}
                {disposition === "fault_report" && subTicketType === "gender_correction" &&
                  <Grid item xs={12} sm={6} md={6}>
                    <p>Enter Correct Gender*</p>
                    <Select
                      className="input"
                      name="sub_ticket_type"
                      variant="outlined"
                      value={correctName}
                      required
                      style={{ width: "100%" }}
                      onChange={(e) =>
                        setCorrectName(e.target.value as string)
                      }
                    >
                      <MenuItem value={"male"}>
                        Male
                      </MenuItem>
                      <MenuItem value={"female"}>
                        Female
                      </MenuItem>
                    </Select>
                  </Grid>}
                {disposition === "fault_report" && subTicketType === "doctor_name_to_be_updated" &&
                  <Grid item xs={12} sm={6} md={6}>
                    <p>Enter Doctor Name*</p>
                    <TextField
                      className="input"
                      name="name"
                      type="text"
                      size="medium"
                      required
                      value={correctName}
                      variant="outlined"
                      onChange={(e) => setCorrectName(e.target.value)}
                      style={{ width: "100%", height: "50px" }}
                    />
                  </Grid>}
                {disposition === "foc_queries" && <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    className="input"
                    name="name"
                    type="number"
                    onWheel={(e: any) => e.target.blur()}
                    label="Old Booking Id"
                    value={FocCreateBookingId}
                    variant="outlined"
                    onChange={(e) => setFocCreateBookingId(e.target.value)}
                    style={{ width: "100%" }}
                  />
                </Grid>}
                {disposition === "refund_query" &&
                  booking &&
                  booking?.booking_type === "b2c" ? (
                  <>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        className="input"
                        name="name"
                        type="number"
                        onWheel={(e: any) => e.target.blur()}
                        label="Booking Id"
                        value={createBookingId}
                        variant="outlined"
                        onChange={(e) => setCreateBookingId(e.target.value)}
                        style={{ width: "100%" }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        className="input"
                        name="name"
                        type="number"
                        onWheel={(e: any) => e.target.blur()}
                        label="Amount"
                        inputProps={{ min: 0, max: finalAmount }}
                        value={createAmount}
                        variant="outlined"
                        onKeyDown={(e) => {
                          blockCharInPhoneField(e);
                        }}
                        required
                        onChange={(e) => {
                          const inputVal = e.target.value;
                          if (+inputVal > +finalAmount) {
                            setCreateAmount(createAmount);
                          } else if (+inputVal < 0) {
                            setCreateAmount(0);
                          } else {
                            setCreateAmount(inputVal);
                          }
                        }}
                        style={{ width: "100%" }}
                      />
                    </Grid>
                  </>
                ) : (
                  ""
                )}

                <Grid item xs={12}>
                  <TextField
                    name="comment"
                    type="text"
                    multiline
                    rows={3}
                    value={description}
                    className="input"
                    variant="outlined"
                    placeholder="Description"
                    onChange={(e) => setDescription(e.target.value as string)}
                    style={{ width: "100%" }}
                    required
                  />
                </Grid>
                {disposition === "refund_query" &&
                  booking &&
                  booking?.booking_type === "b2c" ? (
                  <>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{ height: "50px" }}
                        onClick={raiseComplaint}
                        disabled={description === "" || disposition === ""}
                      >
                        CREATE REFUND TICKET
                      </Button>
                    </Grid>
                    <p
                      style={{
                        marginLeft: "10px",
                        fontWeight: "bolder",
                        fontFamily: "inherit",
                        color: "#2979ff",
                      }}
                    >
                      Note : You can create a refund ticket only up to the
                      amount paid.
                    </p>
                  </>
                ) : (
                  <>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{ height: "50px" }}
                        onClick={raiseComplaint}
                        disabled={description === "" || disposition === ""  || (disposition === "fault_report" &&
                          (subTicketType === "doctor_name_to_be_updated" ||
                            subTicketType === "gender_correction" ||
                            subTicketType === "age_correction" ||
                            subTicketType === "name_correction") &&
                          !correctName) || ( disposition === "fault_report" && (subTicketType === "inaccurate_report")&& (!packageList|| !inaccurateReport))}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  ticketLoader: state.OffLineSupporteReducer.ticketLoader,
  TestList: state.OffLineSupporteReducer.TestList,
});

export default connect(mapStateToProps, {
  initiateRefund,
  raiseNewTicektDisposition,
  getTestList,
})(CommentsModal2);
